<shared-modal
  [isOpen]="isOpen"
  [config]="{
    title: 'Tiempo restante',
    size: 'md',
    showCloseButton: false,
    closeOnBackdrop: false,
    closeOnEscape: false
  }"
  [customContent]="true"
>
  <div class="px-4 sm:px-6 py-4 sm:py-6 relative">
    <!-- Botón cerrar -->
    <button
      type="button"
      (click)="closeModal()"
      class="absolute top-2 right-2 inline-flex items-center justify-center rounded-full bg-white/80 hover:bg-white text-gray-700 hover:text-gray-900 shadow ring-1 ring-gray-200 w-8 h-8"
      aria-label="Cerrar"
    >
      <span class="sr-only">Cerrar</span>
      ✕
    </button>
    <!-- Header / título -->
    <div class="text-center mb-4">
      <h3
        class="text-lg sm:text-xl font-semibold bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent"
      >
        ¡Tu pedido llegó!
      </h3>
      <p class="text-xs sm:text-sm text-gray-600 mt-1">
        Sal a recogerlo en la puerta
      </p>
    </div>

    <!-- Imagen controlada -->
    <div class="flex justify-center mb-5">
      <img
        src="assets/timer/repartidor_timer.png"
        alt="Repartidor en camino"
        class="mx-auto w-56 sm:w-64 md:w-72 max-h-48 object-contain rounded-xl shadow-md ring-1 ring-gray-200"
      />
    </div>

    <!-- Cronómetro estilizado -->
    <div class="flex flex-col items-center">
      <div #digitsRef class="timer-digits bg-gray-900 text-white font-mono tabular-nums tracking-widest text-4xl sm:text-5xl md:text-6xl px-6 py-3 rounded-2xl shadow-lg">
        {{ formatTime(cronometro()) }}
      </div>
      <div class="text-xs sm:text-sm text-gray-500 mt-2">Tiempo restante</div>
    </div>
  </div>
</shared-modal>

<!-- Widget flotante del timer en esquina superior derecha cuando el modal está cerrado -->
@if (!isOpen && cronometro() >= 0) {
  <div class="fixed top-50 right-10 z-50">
    <button #floatRef
      type="button"
      (click)="openModal()"
      class="bg-red-500 text-white text-2xl font-mono tabular-nums px-3 py-2 rounded-lg shadow-lg ring-1 ring-gray-200 hover:bg-gray-800"
      aria-label="Ver detalles del timer"
    >
      {{ formatTime(cronometro()) }}
    </button>
  </div>
}
